<template>
  <div class="flex items-center justify-center min-h-screen bg-gray-100">
    <button @click="goToTasks" class="bg-blue-500 text-white px-6 py-3 rounded hover:bg-blue-600 focus:outline-none focus:ring focus:border-blue-300">
      Go to Tasks
    </button>
  </div>
</template>

<script>
import { useRouter } from 'vue-router'

export default {
  name: 'HomeView',
  setup() {
    const router = useRouter()

    const goToTasks = () => {
      router.push('/tasks')
    }

    return {
      goToTasks
    }
  }
}
</script>

<style scoped>
/* Add your styles here */
</style>